export default Object.freeze({
  // ERR_SEARCH_
  START_LATER_THAN_END: '시작일자는 종료일자보다 클 수 없습니다.',
  KEY_WORD_NULL: '검색어를 입력하세요.',
});
